import { render } from "./ActivityFeeds.vue?vue&type=template&id=2ac04430"
import script from "./ActivityFeeds.vue?vue&type=script&lang=js"
export * from "./ActivityFeeds.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__